import stIdSmartButton from './idSmartButton.component';
import idSmartSummary from './idSmartSummary.component';

export default angular
  .module('st.Integrations.IdSmart', ['st.Core', 'angular-cache'])
  .component('stIdSmartButton', stIdSmartButton)
  .component('idSmartSummary', idSmartSummary)
  .service('idSmartService', ($http, dataService, ID_SMART) => ({
    send: (params) =>
      dataService.apiRequest(null, null, true, null, $http.post, ID_SMART.API.SEND, params)
  }))
  .constant('ID_SMART', {
    API: {
      SEND: '/api/v1/integrations/id-smart/send/'
    }
  });
